import { useCallback } from 'react';

export const useAuthPopup = () => {
    const openAuthPopup = useCallback((onSuccess) => {
        const width = 500;
        const height = 600;
        const left = window.screen.width / 2 - width / 2;
        const top = window.screen.height / 2 - height / 2;

        const popup = window.open(
            '/auth/popup',
            'Revest AI Auth',
            `width=${width},height=${height},top=${top},left=${left}`
        );

        if (!popup) {
            alert('Please allow popups for this website to sign in.');
            return;
        }

        const handleMessage = (event) => {
            if (event.origin !== window.location.origin) return;

            if (event.data.type === 'AUTH_SUCCESS') {
                window.removeEventListener('message', handleMessage);
                if (onSuccess) {
                    onSuccess();
                }
            }
        };

        window.addEventListener('message', handleMessage);
    }, []);

    return { openAuthPopup };
};
